module.exports = __webpack_public_path__ + "img/LR.cf309785.svg";